exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "@media screen and (-ms-high-contrast: active){.trigger-active-3pqC3lo6mwr:focus{transform:scale(1)}}\n", ""]);
// Exports
exports.locals = {
	"active": "trigger-active-3pqC3lo6mwr"
};